import React from "react";
import { CircularProgress } from "@material-ui/core";

type Props = {
  idTeam: number;
  edit: boolean;
  handledCancel: () => {};
  isLoadingDelete: boolean;
};

const CancelButtonTeams = ({ idTeam, edit, handledCancel, isLoadingDelete }: Props) => {
  return (
    <>
      {!edit ? (
        <button
          type="button"
          className="btn btn-secondary mr-3"
          style={{
            color: "white",
            borderColor: "black",
            display: "flex",
            alignItems: "center",
          }}
          onClick={handledCancel}
        >
          Cancelar
          {isLoadingDelete && (
            <CircularProgress style={{ color: "white", width: 16, height: 16, marginLeft: 5 }} />
          )}
        </button>
      ) : (
        <button
          type="button"
          className="btn content-page-cancel-button mr-3"
          style={{
            color: "black",
            borderColor: "black",
          }}
          onClick={handledCancel}
        >
          Voltar
        </button>
      )}
    </>
  );
};

export default CancelButtonTeams;
